<template>
  <div v-if="token" class="text-center">
    <h3 :class="$route.meta.title.styleClasses" v-html="title"></h3>
    <div class="row mt-4">
      <div class="col">
        <b-button class="w-100 mt-2 darken" variant="primary"
          @click="openDialog(getVideoConsultationUrl, $t('menttum.appointment-dialog-msg'), true)"
          style="background-color: #1ABC9C; border-color: white;"><img class="w-6 mr-2"
            src="../../../../../static-appopensalud/img/icons/services/video-white.svg" />{{ $t('menttum.video-consultation') }}
        </b-button>
        <!--  <b-button class="w-100 mt-2 darken" variant="primary" @click="openDialog(getChatConsultationUrl, $t('menttum.appointment-dialog-msg'), true)" style="background-color: #CD840F; border-color: white;"><img class="w-6 mr-2" src="../../../../../static-appopensalud/img/icons/services/chat-white.svg"/>{{ $t('menttum.chat-consultation') }}</b-button> -->
        <b-button class="w-100 mt-2" variant="primary" @click="getWellnessUrl()"><img class="w-6 mr-2"
            src="../../../../../static-appopensalud/img/icons/bienestar-logo.png" />{{ $t('menttum.wellness-services') }}
        </b-button>
        <b-button class="w-100 mt-2 darken" variant="outline-primary"
          @click="openDialog(getWebappUrl,  $t('menttum.webapp-dialog-msg'))" style="background-color: white;"><img
            class="w-6 mr-2" src="../../../../../static-appopensalud/img/icons/person.svg" />{{ $t('menttum.webapp') }}
        </b-button>
        <b-button class="w-100 mt-2 darken" variant="outline-primary" @click="$router.push('/patient/tests')"
        style="background-color: white;"><img class="w-6 mr-2"
            src="../../../../../static-appopensalud/img/icons/morillas-svg-icons/primary/self-test.svg" />{{ $t('menttum.self-evaluation') }}
        </b-button>
        <b-button class="w-100 mt-2 darken" variant="primary" @click="openPacks(false)"
          style="background-color: #D2414C; border-color: white;"><img class="w-6 mr-2"
            src="../../../../../static-appopensalud/img/icons/services/service-packages.svg" />{{ $t('menttum.hire-package') }}
        </b-button>
        <hr>
        <div class="mt-5">
          <span class="mr-3">Powered by </span><a href="https://www.opensalud.es"><img
              style="height: 40px; vertical-align:middle;"
              src="/static-appopensalud/img/logos/RGB_OPENSALUD_AZUL.svg" /></a>
        </div>
      </div>
    </div>

    <base-modal v-model="packsTable.visible">
      <p v-if="packsTable.hireMsgVisible">
        {{ $t('menttum.hire-package-msg') }}
      </p>
      <paginated-table v-if="packsTable.data && landingData" :fields="packsTable.fields" :items="packsTable.data"
        :loading="$store.state.loading">
        <template v-slot:cell(hire)="data">
          <base-button
            @click="$helpers.goToPatientWebApp(`requestAppointment/center/${landingData.centerData.id}/servicesPackages/${data.item.id}`)">
            {{ $t('menttum.hire') }}</base-button>
        </template>
        <!-- <template v-slot:cell(included)="data">
          <div v-for="item in data.item" :key="item.id">
            <span>{{ item.name }}</span>
          </div>goToPatientWebApp+
        </template> -->
      </paginated-table>
    </base-modal>

    <base-dialog v-model="dialog.visible" :okFn="goToPendingUrl" :content="dialog.text"></base-dialog>

  </div>
  <div v-else>
    <p>{{ $t('telemedcare.no-tmc-token-found') }}</p>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import LandingsRepository from '@/repositories/LandingsRepository'
import PaginatedTable from '@/components/base/PaginatedTable'
import BaseModal from '@/components/base/BaseModal'

export default {
  components: {
    BButton,
    'base-dialog': () => import('@/components/base/BaseDialog'),
    PaginatedTable,
    BaseModal
  },
  data () {
    return {
      landingData: null,
      token: window.$cookies.get('api_token'),
      menttumCenterId: '0d6752d4-857a-4610-8c8a-9475e5b17527',
      title: '',
      pendingUrl: '',
      dialog: {
        visible: false,
        text: null
      },
      validToken: false,
      packsTable: {
        visible: false,
        fields: [
          { key: 'description', label: this.$t('name') },
          { key: 'hire', label: this.$t('menttum.hire') },
          { key: 'price', label: this.$t('price'), formatter: (value) => `${value} €` }
          /* { key: 'included', label: this.$t('menttum.included-services') } */
        ],
        data: [],
        hireMsgVisible: false
      }
    }
  },
  watch: {
    'packsTable.visible': function (val) {
      if (!val) {
        this.packsTable.hireMsgVisible = false
      }
    }
  },
  methods: {
    goToPendingUrl () {
      window.location = this.pendingUrl
    },
    openDialog (url, dialogMsg, checkPackages = false) {
      if (checkPackages && (!this.landingData.patientAssociatedData.servicePackages || (this.landingData.patientAssociatedData.servicePackages && (!this.landingData.patientAssociatedData.servicePackages.active && !this.landingData.patientAssociatedData.servicePackages.instantVideo.active && !this.landingData.patientAssociatedData.servicePackages.video.active && !this.landingData.patientAssociatedData.servicePackages.atHome.active && !this.landingData.patientAssociatedData.servicePackages.call.active && !this.landingData.patientAssociatedData.servicePackages.chat.active && !this.landingData.patientAssociatedData.servicePackages.written.active && !this.landingData.patientAssociatedData.servicePackages.active)))) {
        this.openPacks(true)
      } else {
        this.pendingUrl = url
        this.dialog.text = dialogMsg
        this.dialog.visible = true
      }
    },
    getWellnessUrl () {
      this.$ouicareApi.get('Pacientes/GoToWellWo').then((response) => {
        // It will go to hire package modal if package is not
        if (!response.data) {

        }
        window.location = response.data
      })
      /* return this.$helpers.getAppUrl(`api/Pacientes/GoToWellWo`) */
    },
    openPacks (showHireMsg = false) {
      this.packsTable.hireMsgVisible = showHireMsg
      this.packsTable.visible = true
    }
  },
  computed: {
    getChatConsultationUrl () {
      return this.$helpers.getAppUrl(`HomePaciente/Index/#/centers/show/${this.menttumCenterId}/webmailExpress`)
    },
    getVideoConsultationUrl () {
      return this.$helpers.getAppUrl(`HomePaciente#/requestAvailability/center/${this.menttumCenterId}/online`)
    },
    getWebappUrl () {
      return this.$helpers.getAppUrl('HomePaciente')
    }
  },
  beforeCreate () {
    this.$api.get('AppAccount').then((response) => {
      this.title = this.$t('menttum-proxy-view.title.question', { name: response.data.data.user.name })
    })
    LandingsRepository.getLandingData('https://menttum.opensalud.es').then((response) => {
      this.landingData = response.data.data
      this.packsTable.data = this.landingData.centerData.rates.servicePackages
    })
  }
}
</script>

<style scoped>
 .w-6 {
   width: 6%;
 }

 .darken:hover {
  background-image: linear-gradient(rgba(0, 0, 0, 0.1) 0 0);
 }

 .btn-outline-primary:hover {
   color: #135075 !important;
 }
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/external/MenttumProxyView.vue